import { useState } from 'react';
import dayjs from 'dayjs';

import { TaskCriticalityEnum } from 'src/graphql/schema';

import type { ITaskFilters, ITimeRangeValue } from './types';

function getCreatedAfter(range: ITimeRangeValue): string {
  switch (range) {
    case 'today':
      return dayjs().startOf('day').format('YYYY-MM-DD');
    case 'last_2_days':
      return dayjs().subtract(1, 'day').startOf('day').format('YYYY-MM-DD');
    case 'last_7_days':
      return dayjs().subtract(7, 'day').startOf('day').format('YYYY-MM-DD');
    case 'last_30_days':
      return dayjs().subtract(30, 'day').startOf('day').format('YYYY-MM-DD');
  }
}

export function useTasksFilters() {
  const [filters, setFilters] = useState<ITaskFilters>({
    createdAfter: null,
    eventTypes: null,
    criticality: null,
  });
  const [timeRange, setTimeRangeValue] = useState<ITimeRangeValue | null>(null);

  const setTimeRange = (value: ITimeRangeValue | null) => {
    setTimeRangeValue(value);
    setFilters((prev) => ({ ...prev, createdAfter: value ? getCreatedAfter(value) : null }));
  };

  const setEventTypes = (value: string | null) => setFilters((prev) => ({ ...prev, eventTypes: value }));

  const setCriticality = (value: TaskCriticalityEnum | null) => setFilters((prev) => ({ ...prev, criticality: value }));

  return { filters, timeRange, setTimeRange, setEventTypes, setCriticality };
}
